export default __webpack_public_path__ + "static/media/roundInfo-yellow.31ef57b6.svg";